import React from "react";
import {Badge, BadgeProps} from "@mui/material";
import {makeStyles} from "@mui/styles";

export type InlineBadgeProps = Omit<BadgeProps, "anchorOrigin">


const useStyles = makeStyles(() => ({
    root: {
        "& .MuiBadge-badge": {
            position: "inherit !important",
            transform: "none",
            zIndex: "auto",
            width: 24,
            height: 24,
            borderRadius: 24,
        },
    }
}));


export const InlineBadge = (props: InlineBadgeProps) => {
    const classes = useStyles();
    return (
        <Badge
            {...props}
            className={[classes.root, props.className].filter(Boolean).join(" ")}
        />
    )
}